/* src/app/shared-module/components/dialog-info-details/dialog-info-details.component.scss */
button {
  color: var(--ion-color-secondary-shade) !important;
  background: var(--ion-color-primary-tint) !important;
  border-radius: 12px !important;
  margin-right: 10px;
  margin-bottom: 5px;
  padding: 10px !important;
}
h2 {
  margin: 0px !important;
  background-color: var(--ion-color-primary-shade) !important;
  color: white !important;
}
/*# sourceMappingURL=dialog-info-details.component.css.map */
